"use client"

import * as React from "react"
import { ChevronDownIcon } from "lucide-react"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@workspace/ui/components/collapsible"
import { cn } from "@workspace/ui/lib/utils"

/**
 * The folded tail of a long `OrderLineRow` (see its `collapseDetails`). The
 * rows arrive as server-rendered `children`; this only owns the open state.
 * The trigger sits UNDER the content, so "Show less" ends up where the last
 * revealed row stops rather than jumping back above them.
 */
export function OrderLineMore({
  moreLabel,
  lessLabel,
  indentClassName,
  children,
}: {
  moreLabel: string
  lessLabel: string
  indentClassName: string
  children: React.ReactNode
}) {
  const [open, setOpen] = React.useState(false)

  return (
    <Collapsible open={open} onOpenChange={setOpen} className="contents">
      <CollapsibleContent className="flex flex-col gap-1">
        {children}
      </CollapsibleContent>
      <CollapsibleTrigger
        className={cn(
          "flex w-fit items-center gap-1 text-xs font-medium text-muted-foreground hover:text-foreground focus-visible:underline focus-visible:outline-none",
          indentClassName
        )}
      >
        {open ? lessLabel : moreLabel}
        <ChevronDownIcon
          aria-hidden
          className={cn("size-3 transition-transform", open && "rotate-180")}
        />
      </CollapsibleTrigger>
    </Collapsible>
  )
}
